import { useState } from "react";
import { api } from "@/lib/api";
import { Button, Modal, Field, toast } from "@/components/ui";

export function TerritoryWarningModal({ accountId, territoryId, partnerName, stateCode, onDone }: { accountId: string; territoryId: string; partnerName: string; stateCode: string; onDone: () => void }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const dismiss = async () => {
    setBusy(true);
    try {
      await api.post(`/accounts/${accountId}/territory-overrides`, { territoryId, reason });
      onDone();
    } catch (e) { toast((e as Error).message, true); } finally { setBusy(false); }
  };
  return (
    <Modal title="Exclusive territory" onClose={onDone} footer={<><Button onClick={onDone}>Keep warning</Button><Button variant="primary" disabled={busy || reason.trim().length < 3} onClick={dismiss}>Dismiss with reason</Button></>}>
      <div className="card pad" style={{ borderColor: "var(--status-yellow-border)" }}>
        <strong>{stateCode}</strong> is an exclusive territory for <strong>{partnerName}</strong>. This account is not linked to that partner.
      </div>
      <Field label="Reason for proceeding (logged)"><textarea className="textarea" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Customer came to us directly; partner informed on Oct 14." /></Field>
    </Modal>
  );
}

export function TerritoryBanner({ accountId, warning, onDismissed }: { accountId: string; warning: { territoryId: string; partnerName: string; stateCode: string }; onDismissed: () => void }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="card pad row gap-10 wrap" style={{ borderColor: "var(--status-yellow-border)" }}>
        <span>⚠ <strong>{warning.stateCode}</strong> is an exclusive territory for <strong>{warning.partnerName}</strong>.</span>
        <Button size="md" className="ml-auto" onClick={() => setOpen(true)}>Dismiss</Button>
      </div>
      {open && <TerritoryWarningModal accountId={accountId} territoryId={warning.territoryId} partnerName={warning.partnerName} stateCode={warning.stateCode} onDone={() => { setOpen(false); onDismissed(); }} />}
    </>
  );
}
